import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Route, Link } from 'react-router';
import moment from 'moment';
import ReactDOM from 'react-dom';

import {
  Well,
  Table,
  Button,
  BPanel,
  Col,
  FormControl,
  FormGroup
} from '@sketchpixy/rubix';
var DatePicker = require("react-bootstrap-date-picker");
import { Flights } from '../../collections/flights/flights';
import { Reactive } from '../common/Reactive.mixin.js';

@Reactive({
	subscriptions: ["flights", "users"]
})
export default class MyFlightsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    //set start and ending date :
    this.state.startDate = moment().startOf('year').format();
    this.state.endDate = moment().format();

    props.ready.then(() => {
    	this.setState({
    		flights: Flights.find({pilotId: Meteor.user()._id, createdAt:{ $gte: moment(this.state.startDate).toDate() , $lte: moment(this.state.endDate).toDate() }}).fetch().reverse(),
        pilots: Meteor.users.find({roles:{$in:['pilot']}}).fetch(),
      });

    });

  }

  update() {

    let pilot = ReactDOM.findDOMNode(this.refs.pilot).value.trim();
    let status = [ReactDOM.findDOMNode(this.refs.status).value.trim()];


    if(!status[0]) {
      status = ["preparing", "prepared", "cancelled", "validated"];
    }

    if(!_.includes(Meteor.user().roles, 'god')) {
      pilot = Meteor.user()._id;
    }

    if(!pilot) {
      this.setState({
  			flights: Flights.find({status: { $in: status}, date:{ $gte: moment(this.state.startDate).toDate(), $lte: moment(this.state.endDate).toDate() }}, {sort: { date: -1 }}).fetch(),
  		});
    } else {
  		this.setState({
  			flights: Flights.find({pilotId: pilot, status: {$in: status}, date:{ $gt: moment(this.state.startDate).toDate(), $lt: moment(this.state.endDate).toDate() }}, {sort: { date: -1 }}).fetch(),
  		});
    }
  }


  render() {

    if(!this.state.flights) {
    	return (<div>Chargement...</div>);
    }

    return (
      <div>
        <BPanel header="Mes vols">
            { _.includes(Meteor.user().roles, 'god') &&
            <BPanel header="Filtrer par pilote">
              <FormControl id='pilot' componentClass="select" type="select" ref="pilot">
                <option value=''>Tous les pilotes</option>
                {this.state.pilots.map((pilot) =>
                    <option value={pilot._id}>{pilot.displayName()}</option>
                )}
              </FormControl>
            </BPanel>
            }
            <Col sm={1}>
              Du
            </Col>
            <Col sm={5}>
              <DatePicker
              dayLabels={['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']}
							monthLabels={['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']}
              id="start_date" value={this.state.startDate} onChange={(value) => this.setState({ startDate: value })}/>
            </Col>
            <Col sm={1}>
              Au
            </Col>
            <Col sm={5}>
              <DatePicker
              dayLabels={['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']}
							monthLabels={['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']}
              id="end_date" value={this.state.endDate} onChange={(value) => this.setState({ endDate: value })} />
            </Col>
            <br/><br/><hr/>
            <Col sm={1}>
              Status
            </Col>
            <Col sm={3}>
              <FormControl id='status' componentClass="select" type="select" ref="status" onChange={(value) => this.setState({ status: value })}>
                <option value=''>Tous les vols</option>
                <option value='validated'>Clôturé</option>
                <option value='preparing'>En préparation</option>
                <option value='cancelled'>Annulé</option>
              </FormControl>
            </Col>
            <Col sm={2}>
            	<Button onClick={::this.update}>Changer</Button>
            </Col>
        </BPanel>

        <BPanel header={ "Liste de vos vols (" + this.state.flights.length + " vols) :"}>
          <Table responsive>
            <thead>
              <tr>
              <th>Date</th>
              <th>Pilote</th>
              <th>Période</th>
              <th>Status</th>
              <th>Lieu</th>
              <th>Actions</th>
              </tr>
            </thead>
            <tbody>
            	{this.state.flights.map((flight) =>
            		<tr>
            			<td>{flight.getDisplayDate()}</td>
                  {flight.getPilote() &&
                    <td>{flight.getPilote().displayName()}</td>
                  }
                  {!flight.getPilote() &&
                    <td>Pilote supprimé</td>
                  }
            			<td>{flight.getPeriod()}</td>
            			<td>{flight.getStatus()}</td>
            			<td>{flight.getPlace()}</td>
            			<td><Link to={'/flights/' + flight._id + '/detail'}><Button bsStyle="primary">Voir</Button></Link></td>
            		</tr>
            	)}
            </tbody>
          </Table>
        </BPanel>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/statistiques/MyFlights.page.js
 **/